import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { RecipeSpot } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { TranslateSafePipe } from '../../../../@shared/translate-safe/translate-safe.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf, NgFor, KeyValuePipe } from '@angular/common';

@Component({
    selector: 'app-recipe-header',
    templateUrl: './recipe-header.component.html',
    styleUrls: ['./recipe-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgFor, KeyValuePipe, TranslateModule, TranslateSafePipe]
})
export class RecipeHeaderComponent implements OnInit {
    public headerInformation: { [key: string]: string | undefined } = {};

    @Input()
    public data: RecipeSpot;

    ngOnInit(): void {
        // Pick certain props from data object
        const { yieldText, shelfLife, storage, recipeCuisine } = this.data;
        this.headerInformation = { yieldText, shelfLife, storage, recipeCuisine };
    }
}
